const landing_page = {
  aboutUs: "معلومات عنا", // translated 
  topPackages: "أعلى الحزم", // translated 
  featuredHotels: "الفنادق المميزة", // translated 
  topTours: "أعلى الجولات", // translated 
  whatOurMembersSay: "ماذا يقول أعضاؤنا...", // translated 
  followUsOnInstagram: "متابعتنا على الانستقرام", // translated 
  pleaseWait: "انتظر من فضلك...", // translated 
  packages: "الحزم", // translated 
  ourPartners: "شركاؤنا", // translated 
  trustedCarHirePartners: "شركاء تأجير السيارات الموثوق بهم", // translated 
  learnMore: "يتعلم أكثر", // translated 
};



export default landing_page;
